
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { User } from '@shared/models';
	import MobileMenu from './MobileMenu.vue';
	import firebase from 'firebase';

	@Component({
		components: {
			MobileMenu,
		},
	})
	export default class TopBar extends BaseView {

		public $refs!: { mobileMenu: MobileMenu };
		public user: User = null;

		public async mounted() {
			firebase.auth().onAuthStateChanged((user) => {
				this.user = new User({ displayName: user.displayName });
			});
		}

		public async logout() {
			await firebase.auth().signOut();
			this.$router.push({ name: 'login' });
		}

	}
	
